<template>  
  <svg :class="computedClass" :width="width" :height="height">
    <use :xlink:href="'../assets/svg/svgIcons.svg#' + icon" />
  </svg>
</template>

<script>  

  export default {  
    props: ['className', 'icon', 'width', 'height'],
    computed: {
      computedClass () {
        return this.className ? this.className : 'default'; 
      }
    }
  };

</script>

<style lang="scss" scoped>  

  @import '../css/global.scss';

  .icon {
    display: inline-block;
  }

  .default {
    fill: $black54;
  }

</style>  


// WEBPACK FOOTER //
// src/components/Icon.vue